export const COMPETITORS_LIST = [
  {
    // Первый в списке будет дефолтным значением, если город не из списка
    sourceTown: 'Москва',
    competitors: ['Леруа Мерлен', 'Петрович', 'Все инструменты'],
  },
  {
    sourceTown: 'Павловский Посад',
    competitors: ['Леруа Мерлен', 'Петрович', 'Все инструменты'],
  },
  {
    sourceTown: 'Ишим',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Домострой'],
  },
  {
    sourceTown: 'Заводоуковск',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Домострой'],
  },
  {
    sourceTown: 'Мегион',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Стройплатформа'],
  },
  {
    sourceTown: 'Сургут',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Стройплатформа'],
  },
  {
    sourceTown: 'Нефтеюганск',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Стройплатформа'],
  },
  {
    sourceTown: 'Нижневартовск',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Стройплатформа'],
  },
  {
    sourceTown: 'Пермь',
    competitors: ['Леруа Мерлен', 'Баумолл', 'Все инструменты'],
  },
  {
    sourceTown: 'Тюмень',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Домострой'],
  },
  {
    sourceTown: 'Ялуторовск',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Домострой'],
  },
  {
    sourceTown: 'Тобольск',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Домострой'],
  },
  {
    sourceTown: 'Екатеринбург',
    competitors: ['Леруа Мерлен', 'Строймаркет Сатурн', 'Дом', 'ТСК'],
  },
  {
    sourceTown: 'Нижний Тагил',
    competitors: ['Леруа Мерлен', 'Дом', 'ТСК'],
  },
  {
    sourceTown: 'Березовский',
    competitors: ['Леруа Мерлен', 'Дом', 'ТСК'],
  },
  {
    sourceTown: 'Лангепас',
    competitors: ['Леруа Мерлен', 'Уралинтерьер', 'Стройплатформа'],
  },
  {
    sourceTown: 'Самара',
    competitors: ['Леруа Мерлен', 'Строймаркет Сатурн', 'Максидом'],
  },
  {
    sourceTown: 'Челябинск',
    competitors: ['Леруа Мерлен', 'Дом', 'Стройбаза', 'Строймаркет Сатурн'],
  },
];
